import React from 'react';
import Button from './Button';
import './ui.css';

/**
 * Centred empty state for a table card: 48px icon in #DDD6D1, a 14px/600 line,
 * a 13px explanation, then the screen's primary action.
 */
export default function EmptyState({
  icon = 'bx-search-alt',
  title = 'Nothing here yet',
  description,
  actionLabel,
  actionIcon,
  onAction,
}) {
  return (
    <div className="sv-empty">
      <i className={`bx ${icon} sv-empty__icon`} aria-hidden="true" />
      <div className="sv-empty__title">{title}</div>
      {description && <div className="sv-empty__desc">{description}</div>}
      {actionLabel && onAction && (
        <div className="sv-empty__action">
          <Button variant="primary" icon={actionIcon} onClick={onAction}>
            {actionLabel}
          </Button>
        </div>
      )}
    </div>
  );
}
